import {Injectable} from '@angular/core';
import {Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild} from '@angular/router';

import {Logger} from '../logger.service';
import {CredentialsService} from './credentials.service';

const log = new Logger('AuthenticationGuard');

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivateChild {

  constructor(private router: Router,
              private credentialsService: CredentialsService) {
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // TODO for test only
    return true;
    //
    // if (this.credentialsService.isAuthenticated()) {
    //     return true;
    // }
    //
    // log.debug('Not authenticated, redirecting and adding redirect url...');
    // // clear
    // this.credentialsService.setCredentials();
    // this.router.navigate(['auth', 'login'], { queryParams: { redirect: state.url }, replaceUrl: true });
    // return false;
  }

}
